module.exports = __webpack_public_path__ + "static/Zuppa-Inglese-(Eierpunsch)-e3a17952b592cf3b0d89aa3ae7873918.png";